import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@mui/material';
import authService from 'src/services/authService';
import { returnFromSignInAs } from 'src/actions/accountActions';

// CON-1966. While signed in as someone (a saved original session exists),
// a small amber pill in the top bar beside the user's name: "Viewing as
// [first name] · Return". It stays out of the page itself so support can
// screenshot the consultant's pages clean. Return switches straight back
// to the original account. The Chat app's equivalent is the drawer's
// "Viewing as this user" chip and its Return item (CON-1403).
function SignInAsPill() {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.account);
  const [returning, setReturning] = useState(false);
  const original = authService.getSignInAsOriginal();

  if (!original || !user?.id) return null;

  const handleReturn = () => {
    setReturning(true);
    dispatch(returnFromSignInAs(user.id));
  };

  return (
    <Box
      role="status"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        px: 1.25,
        py: 0.25,
        borderRadius: 999,
        backgroundColor: '#FEF3C7',
        border: '1px solid #F59E0B',
        color: '#92400E',
        fontFamily: (theme) => theme.typography.fontFamily,
        fontSize: 13,
        fontWeight: 600,
        whiteSpace: 'nowrap',
      }}
    >
      <span>{`Viewing as ${user.firstName || 'this user'} ·`}</span>
      <Box
        component="button"
        type="button"
        onClick={handleReturn}
        disabled={returning}
        aria-label={`Return to ${original.label}`}
        sx={{
          background: 'none',
          border: 'none',
          padding: 0,
          color: 'inherit',
          font: 'inherit',
          textDecoration: 'underline',
          cursor: 'pointer',
        }}
      >
        Return
      </Box>
    </Box>
  );
}

export default SignInAsPill;
